//                                                   
import { repo } from '@bi/sync';
//        
export const UsersRepository = repo.adm.UsersRepository;
export const DatasetsRepository = repo.adm.DatasetsRepository;
export const TopicsRepository = repo.adm.TopicsRepository;
export const TopicDatasetMapsRepository = repo.adm.TopicDatasetMapsRepository;
export const UserGroupsRepository = repo.adm.UserGroupsRepository;
export const UserDatasetMapsRepository = repo.adm.UserDatasetMapsRepository;
export const DataSourceRepository = repo.adm.DataSourceRepository;
export const ConfigsRepository = repo.adm.ConfigsRepository;
export const OneConfigRepository = repo.adm.OneConfigRepository;
